export default import.meta.ROLLUP_FILE_URL_9RZcgwEfAhCNnFz6ZsPaug